// Currency-aware money entry. Display formatting stays in `formatMoney`
// (`@sylviq/ui-core`); this module owns converting an entered major-unit
// string into the integer minor units the API contracts take.
import { minorUnitsFor } from "@sylviq/ui-core";

/** Entered positive amount to minor units in `currency` (0 for JPY, 3 for
 * KWD, 2 by default), or null when it cannot represent a positive money
 * value. Use with a document/source currency that is actually in scope —
 * USD-implicit document-line forms keep their own cents-only helper. */
export function toMinorUnits(amount: string, currency: string): number | null {
  const trimmed = amount.trim();
  if (!trimmed) return null;
  const value = Number(trimmed);
  if (!Number.isFinite(value) || value <= 0) return null;
  const minor = Math.round(value * 10 ** minorUnitsFor(currency));
  return Number.isSafeInteger(minor) && minor > 0 ? minor : null;
}

/** HTML number-input `step` and placeholder for an amount entered in
 * `currency` (e.g. `1`/`0` for JPY, `0.001`/`0.000` for KWD). */
export function minorUnitEntry(currency: string): {
  step: string;
  placeholder: string;
} {
  const decimals = minorUnitsFor(currency);
  return {
    step: (10 ** -decimals).toFixed(decimals),
    placeholder: (0).toFixed(decimals),
  };
}
